import { Button } from '@pms-digital/design-system';

export interface SetupImportFailureProps {
  message: string;
  onRetry: () => void;
}

/**
 * A network or server failure while reading the file. Unlike a refusal the
 * file itself may be fine, so the user can retry it; « Changer de source »
 * sits on the source line above, as in every other result state.
 */
export function SetupImportFailure({ message, onRetry }: SetupImportFailureProps) {
  return (
    <div
      role="alert"
      data-testid="setup-import-failure"
      className="rounded-md border-2 border-rouge bg-rouge-tint p-4 text-small"
    >
      <h3 className="mb-1 font-bold text-body text-rouge-deep">Lecture du fichier impossible</h3>
      <p className="my-1">{message}</p>
      <Button variant="secondary" type="button" size="sm" onClick={onRetry}>
        Réessayer
      </Button>
    </div>
  );
}
